<div *ngIf="isDefault">
  <div *ngFor="let accordionSection of apiReferenceAccordianSections; let i = index">
    <h3>{{ accordionSection.subBody }}</h3>
    <div class="accordion-apiDoc">
      <div class="card-header">
        <h4 (click)="toggleCollapsed(i)" class="flex-text">
          <div [ngClass]="getArrowIcons(i)" class="arrow-icon">
            {{ accordionSection.title }}
          </div>
        </h4>
      </div>
      <div [ngClass]="getAccordionStyle(i)" class="mt-3">
        <!-- <div [innerHTML]="accordionData.subBody || '' | mdToHtml"></div> -->
        <div class="collapsible card-body" [innerHTML]="accordionSection.body || '' | mdToHtml"></div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="responsePage">
  <div *ngFor="let accordionSection of apiReferenceAccordianSections; let i = index">
    <h3>{{ accordionSection.subBody }}</h3>
    <div class="accordion-apiDoc">
      <div class="card-header">
        <h4 (click)="toggleCollapsed(i)" class="flex-text">
          <div [ngClass]="getArrowIcons(i)" class="arrow-icon">
            {{ accordionSection.title }}
          </div>
        </h4>
      </div>
      <div [ngClass]="getAccordionStyle(i)" class="mt-3">
        <!-- <div [innerHTML]="accordionData.subBody || '' | mdToHtml"></div> -->
        <div class="collapsible card-body" [innerHTML]="accordionSection.body || '' | mdToHtml"></div>
      </div>
    </div>
  </div>
</div>
